<template>
    <div class="task-center">
        <div
            ref="taskBtn"
            class="task-center-con"
            @click="handleTasCenterMore"
            @mouseenter="onTaskCenterMouseEnter"
        >
            任务中心
            <span
                v-if="generatingCount"
                class="task-center-num"
            >
                {{ generatingCount }}
            </span>
        </div>
        <veui-popover
            :open.sync="showTaskTip"
            theme="ai"
            target="taskBtn"
            position="bottom-end"
            :hide-delay="100"
        >
            <div class="task-center-tooltip">
                <div class="task-center-header">
                    任务中心
                </div>
                <div
                    class="task-center-main"
                >
                    <template v-if="!showLoading && tastList.length">
                        <div
                            v-for="item in tastList"
                            :key="item.value"
                            class="task-center-item"
                            @click="handleTastListItemClick(item)"
                        >
                            <div
                                :class="`task-center-item-pic task-center-item-${item.type}`"
                            >
                                <span
                                    class="task-center-item-pic-con"
                                    :style="{
                                        backgroundImage: `url(${optimizeImgUrl(item.url, 'resize,m_lfit,w_200')})`,
                                    }"
                                >
                                </span>
                            </div>
                            <div class="task-center-item-info">
                                <div class="task-center-item-title">
                                    {{ item.title }}
                                </div>
                                <div
                                    v-if="isGeneratingDigitalHuman(item)"
                                    class="task-center-item-progress"
                                >
                                    <veui-progress
                                        :value="item.progress"
                                        :desc="true"
                                        :decimal-place="1"
                                        :min="0"
                                        :max="100"
                                    />
                                </div>
                                <div
                                    v-else
                                    class="task-center-item-status"
                                    :class="{'task-center-item-fail': item.status === '生成失败'}"
                                >
                                    {{ item.status }}
                                    <span
                                        v-if="checkMashupFail(item)"
                                        :ref="`${item.taskId}-mashupFailRef`"
                                        class="mashup-fail"
                                        @mouseenter="handleShowTooltip(item)"
                                    >
                                        <veui-icon
                                            name="info-circle"
                                            class="mashup-fail-icon"
                                        />
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div
                            class="task-center-more"
                            @click="handleTasCenterMore"
                        >
                            查看更多
                        </div>
                    </template>
                    <div
                        v-if="showLoading"
                        class="task-center-main-loading"
                    >
                        <veui-loading
                            class="loading"
                            loading
                            ui="strong"
                        >
                            正在加载中
                        </veui-loading>
                    </div>
                    <div
                        v-if="showMainEmpty"
                        class="task-center-main-empty"
                    >
                        <veui-empty desc="暂无生成内容"/>
                    </div>
                </div>
            </div>

            <veui-tooltip
                v-if="failItem"
                :open.sync="showFailTooltip"
                :target="failRef"
                theme="d22"
                overlay-class="mashup-fail-tooltip"
                :hide-delay="100"
            >
                {{ failItem.errors || '系统异常' }}，可尝试点此
                <veui-button
                    ui="text strong"
                    @click="handleReGenerate"
                >
                    重新生成
                </veui-button>
            </veui-tooltip>
        </veui-popover>
    </div>
</template>

<script>
import store from '@/store';
import {Progress, Empty, Loading, Popover, Tooltip, Button, Icon} from 'veui';
import {getRouteQuery, optimizeImgUrl} from '@/common/util';
import {allDigitalSource} from '@/config/const';

export default {
    name: 'taskCenter',
    inject: ['$toast', 'model'],
    components: {
        'veui-progress': Progress,
        'veui-empty': Empty,
        'veui-loading': Loading,
        'veui-popover': Popover,
        'veui-tooltip': Tooltip,
        'veui-button': Button,
        'veui-icon': Icon
    },
    props: {
    },
    data() {
        return {
            mouseHovered: false,
            taskInfoInterval: null,
            showTaskTip: false,
            showMainEmpty: false,
            showLoading: false,
            tastList: [],
            generatingCount: 0,
            routeQuery: getRouteQuery() || {},
            showFailTooltip: false,
            optimizeImgUrl,
            failItem: null,
            failRef: null
        };
    },
    computed: {
    },
    mounted() {
        // 渲染后立即加载一次，便于鼠标移入时不用看到loading。但是不开启定时，鼠标移入后才开启即可。
        this.getTaskInfo();
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
    },
    beforeDestroy() {
        // 组件销毁时清除定时器
        if (this.taskInfoInterval) {
            clearInterval(this.taskInfoInterval);
        }
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    },
    methods: {
        handleVisibilityChange() {
            if (document.hidden) {
                this.clearTaskInfoInterval();
            } else {
                this.startTaskInfoInterval();
            }
        },
        startTaskInfoInterval() {
            if (!this.taskInfoInterval) {
                this.taskInfoInterval = setInterval(this.getTaskInfo, 10000);
            }
        },
        clearTaskInfoInterval() {
            if (this.taskInfoInterval) {
                clearInterval(this.taskInfoInterval);
                this.taskInfoInterval = null;
            }
        },
        async onTaskCenterMouseEnter() {
            try {
                if (this.mouseHovered) {
                    return;
                }
                this.mouseHovered = true;
                this.showTaskTip = true;
                // 如果初始的加载已经有数据了则不显示loading态了
                this.showLoading = this.tastList.length < 1;
                // 立即触发一次 getTaskInfo
                this.getTaskInfo();
                // 每隔 10 秒触发一次 getTaskInfo
                this.startTaskInfoInterval();
            } catch (error) {
                console.error(error);
            }
        },
        async getTaskInfo() {
            try {
                const data = await store.dispatch('getTaskCenterInfo', {
                    nums: 5,
                    digitalHumanSourceList: allDigitalSource,
                    imageTypeList: ['12', '18', '19', '10', '17', '20', '26', '28', '31', '32']
                });
                const tastList = this.formatTaskInfo(data);
                this.tastList = tastList;
                this.generatingCount = tastList.filter(item => item.status === '生成中').length;
                this.showMainEmpty = !Boolean(tastList.length);
            } catch (error) {
                console.error(error);
            } finally {
                this.showLoading = false;
            }
        },
        getImageTitleByType(type) {
            const imageTypeMap = new Map([
                [10, '智能扩图'],
                [11, '批量裁剪'],
                [12, '智能抠图'],
                [20, 'IP封面生成'],
                [26, '模板制图'],
                [28, '批量生图'],
                [17, '多图拼接']
            ]);
            return imageTypeMap.get(type) || '一键出图';
        },
        formatTaskInfo(data) {
            const statusMap = {
                digitalHuman: {
                    2: '生成中',
                    3: '生成成功',
                    default: '生成失败'
                },
                image: {
                    1: '生成中',
                    3: '生成失败',
                    default: '生成成功'
                },
                text: {
                    default: '生成成功'
                }
            };
            const transformedData = data.map(item => {
                const key = Object.keys(item)[0];
                const data = item[key];
                const nameMap = {
                    text: [3, 6, 9].includes(data.taskType)
                        ? '口播文案'
                        : [11].includes(data.taskType) ? '情景剧本' : '文案任务',
                    image: this.getImageTitleByType(data.taskType),
                    digitalHuman: data.videoName
                };
                const status = statusMap[key][data.status] || statusMap[key].default;
                const transformedItem = {
                    errors: data.errors,
                    taskId: data.taskId,
                    type: key,
                    title: key === 'digitalHuman'
                        ? nameMap[key] : `${nameMap[key]}-${this.formatCreateTime(data.createTime)}`,
                    taskType: data?.taskType || '',
                    status
                };

                if (key === 'digitalHuman') {
                    transformedItem.progress = data.progress;
                    transformedItem.url = data.thumbnail;
                } else if (key === 'image') {
                    transformedItem.url = data.url;
                }

                return transformedItem;
            });
            return transformedData;
        },
        formatCreateTime(data) {
            return data.replace(/(\d{4})-(\d{2})-(\d{2}) (\d{2}:\d{2}):\d{2}/, '\$1\$2\$3_\$4');
        },
        isGeneratingDigitalHuman(item) {
            return item.type === 'digitalHuman' && item.status === '生成中';
        },
        handleTastListItemClick(val) {
            const routeMap = {
                digitalHuman: 'videoTask',
                image: 'imageTask',
                text: [3, 6, 9, 11].includes(val?.taskType) ? 'scriptTask' : 'textTask'
            };
            this.$router.push({
                query: this.routeQuery,
                name: routeMap[val.type]
            });
            this.showTaskTip = false;
        },
        handleTasCenterMore() {
            this.$router.push({
                query: this.routeQuery,
                name: 'videoTask'
            });
            this.showTaskTip = false;
        },
        checkMashupFail(item) {
            // 接口没区分类型，暂时用名称区分
            if (item.title.indexOf('一键成片') >= 0 && item.status === '生成失败') {
                return true;
            }
        },
        handleShowTooltip(item) {
            this.failItem = item;
            this.showFailTooltip = true;
            this.failRef = `${item.taskId}-mashupFailRef`;
        },
        async handleReGenerate() {
            const taskId = this.failItem?.taskId;
            if (!taskId) {
                this.$toast.error('查询任务失败，请到任务列表查看');
            }
            let params = {pageNum: 1, pageSize: 10, taskId: [taskId]};
            let result = {};
            try {
                result = await this.model.basicInfo.queryTasksV2(params);
                // 取出轨道信息，到sdk解析
                let {material, renderType} = result?.items[0];
                material = JSON.parse(material);
                const createType = renderType === 60 ? 'play' : 'normal';
                material.createType = createType;
                this.$router.push({
                    name: 'MashupCreateV2',
                    params: {
                        mashConfig: JSON.stringify(material)
                    },
                    query: {
                        timestamp: new Date().getTime()
                    }
                });
            }
            catch (err) {
                this.$toast.error(err.message, '列表获取失败');
            }
        }
    }
};
</script>

<style scoped lang="less">
.task-center {
    position: relative;
    &-con {
        padding: 4px 12px;
        background: rgba(255, 255, 255, 0.5);
        border-radius: 16px;
        color: #282C33;
        font-size: 14px;
        font-weight: 400;
        font-family: 'PingFang SC';
        display: flex;
        align-items: center;
        cursor: pointer;
    }
    &-num {
        display: inline-block;
        width: 16px;
        height: 16px;
        padding: 1px;
        line-height: 1;
        color: #fff;
        background: #0054E6;
        text-align: center;
        border-radius: 100%;
        margin-left: 4px;
    }
    &-header {
        color: #282C33;
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        margin: 0 8px 6px 8px;
    }
    &-more {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        text-align: center;
        color: #3A5BFD;
        width: 100%;
        background-color: #fff;
        bottom: 16px;
        padding-top: 16px;
        left: 0;
        cursor: pointer;
    }
    &-main {
        min-height: 284px;
        position: relative;
        &-empty {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        &-loading {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            line-height: 26px;
            font-weight: 400;
            font-size: 14px;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
        }
        /deep/ .veui-loading-text {
            color: #545B66;
        }
    }
    &-item {
        display: flex;
        border-radius: 10px;
        padding: 6px 8px;
        cursor: pointer;
        &:hover {
            background: rgba(110, 160, 247, 0.07);
        }
        &-progress {
            width: 180px;
        }
        &-pic {
            width: 56px;
            height: 56px;
            margin-right: 12px;
            border-radius: 6px;
            background-color: rgba(126, 155, 206, 0.15);
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
            overflow: hidden;
            &-con {
                display: inline-block;
                width: 100%;
                height: 100%;
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center;
            }
        }
        &-text {
            background-color: unset;
            background-image: url(../../assets/taskText.png);
        }
        &-digitalHuman {
            background-color: unset;
            background-image: url(../../assets/taskVideo.png);
        }
        &-title {
            width: 200px;
            color: #282C33;
            font-size: 14px;
            line-height: 20px;
            font-weight: 400;
            margin-bottom: 8px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        &-status {
            color: #009940;
            font-weight: 400;
            font-size: 12px;
            line-height: 16px;
        }
        &-fail {
            color: #D9150B;
            font-weight: 400;
            font-size: 12px;
            line-height: 16px;
            display: flex;
            align-items: center;
            gap: 4px;
        }
    }
}
/deep/ .veui-ai-tooltip-content {
    margin: 16px 8px !important;
}
/deep/ .veui-ai-progress-rail {
    width: 100px !important;
}
/deep/ .veui-ai-tooltip {
    width: 320px;
    max-width: 320px;
    padding: 0;
    border-radius: 12px!important;
}
/deep/ .veui-ai-tooltip-arrow {
    right: 30px!important;
    &::after {
        width: 11.89px;
        height: 11.89px;
        top: -8.408px;
        box-shadow: none;
    }
}
.mashup-fail {
    display: flex;
    gap: 4px;
    width: fit-content;
    &-icon {
        color: #848B99;
    }
}
.mashup-fail-tooltip {
    /deep/ .veui-tooltip {
        padding: 16px;
        border-radius: 6px;
        max-width: 400px;
        &-content {
            font-size: 14px;
        }
    }
}
</style>
